import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';

const ActionButton = ({
  label, onClick, variant, classes,
}) => (
  <Button
    variant={variant}
    color="primary"
    className={classes.root}
    aria-label={label}
    onClick={onClick}
  >
    {label}
  </Button>
);

ActionButton.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['outlined', 'contained']),
  classes: PropTypes.object,
  onClick: PropTypes.func,
};

ActionButton.defaultProps = {
  variant: 'outlined',
  classes: {},
  onClick: null,
};

export default ActionButton;
